module.exports = __webpack_public_path__ + "img/videoBanner.5de81fea.png";